// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a306d2d4","455":"b46c052a","977":"857afee6"}[chunkId] + ".chunk.js";
};